import { type DocEntry, type Manifest, ManifestSchema } from "@manifest/schema.ts";

export type { Manifest, DocEntry };

export async function loadManifest(url = "/manifest.json"): Promise<Manifest> {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`manifest fetch failed: ${res.status} ${res.statusText}`);
  }
  const raw = await res.json();
  return ManifestSchema.parse(raw);
}

export function getDocsByCluster(manifest: Manifest): Record<string, DocEntry[]> {
  const grouped: Record<string, DocEntry[]> = {};
  for (const doc of manifest.docs) {
    const arr = grouped[doc.cluster] ?? [];
    arr.push(doc);
    grouped[doc.cluster] = arr;
  }
  for (const cluster of Object.keys(grouped)) {
    grouped[cluster]?.sort((a, b) => a.slot - b.slot);
  }
  return grouped;
}

export function getDocById(manifest: Manifest, id: string): DocEntry | undefined {
  return manifest.docs.find((d) => d.id === id);
}

export interface Neighbours {
  prev: DocEntry | undefined;
  next: DocEntry | undefined;
}

export function getNeighbours(manifest: Manifest, id: string): Neighbours {
  const doc = getDocById(manifest, id);
  if (!doc) return { prev: undefined, next: undefined };
  const sameCluster = manifest.docs
    .filter((d) => d.cluster === doc.cluster)
    .sort((a, b) => a.slot - b.slot);
  const idx = sameCluster.findIndex((d) => d.id === id);
  return {
    prev: idx > 0 ? sameCluster[idx - 1] : undefined,
    next: idx < sameCluster.length - 1 ? sameCluster[idx + 1] : undefined,
  };
}
